/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_TermsInputs */

const cs_draft_group_terms = /** @type {(inputs: Draft_Group_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podmínky`)
};

const en_draft_group_terms = /** @type {(inputs: Draft_Group_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Draft_Group_TermsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_terms = /** @type {((inputs?: Draft_Group_TermsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_TermsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_terms(inputs)
	return cs_draft_group_terms(inputs)
});